import Vue from 'vue';

Vue.component('customer-index', () =>
    import(/* webpackChunkName: 'customer-index' */ './customer-index.vue'),
);

Vue.component('customer-profile', () =>
    import(/* webpackChunkName: 'customer-detail' */ './customer-profile.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/customer/index.js